import { render } from "./MiddleCompo.vue?vue&type=template&id=76c81bbc"
import script from "./MiddleCompo.vue?vue&type=script&lang=js"
export * from "./MiddleCompo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__